export const MINIMUM_HALL_ID = 0;
export const MAXIMUM_HALL_ID = 7;
